import { Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../components/form-item'
import { FormSection } from '../../../components/form-section'

export function CampaignPromptSection() {
    const { t } = useTranslation()

    return (
        <FormSection title={t('Instructions')}>
            <FormItem
                name={['data', 'prompt']}
                label={t('Conversation instructions')}
                rules={[{ required: true, whitespace: true, message: t('Enter your conversation instructions') }]}
            >
                <Input.TextArea
                    autoSize={{ minRows: 6, maxRows: 25 }}
                    placeholder={t(
                        'e.g. Confirm attendance for our event, ask about dietary preferences, and thank the participant. Evaluate the outcome based on confirmed attendance.'
                    )}
                />
            </FormItem>
        </FormSection>
    )
}
